import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeProps as _normalizeProps, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue";
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useViewStore } from 'src/stores/view';
import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';
import { AppGeneralVariables } from 'src/plugins/general/variables';
import generalHeader from 'src/layouts/components/header/header.vue';
import desktopHeader from 'src/layouts/standard/components/header/desktop.vue';
import mobileHeader from 'src/layouts/standard/components/header/mobile.vue';
import mobileOptions from './mobileOptions.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'standardHeader',
    props: {
        homeHeader: Boolean,
        hideHeader: Boolean
    },
    setup(__props) {
        const props = __props;
        const { styleType } = AppGeneralVariables();
        const headerComponentProperties = computed(() => {
            if ((styleType.value === 'desktop') && (!props.hideHeader)) {
                return {
                    homeHeader: props.homeHeader
                };
            }
            return {};
        });
        const $q = useQuasar();
        const vueRouter = useRouter();
        const viewStore = useViewStore();
        const drawer = computed({
            get: () => viewStore.drawer,
            set: (value) => {
                if (value) {
                    $q.sessionStorage.set('openingChat', true);
                }
                viewStore.toggleDrawer(value);
            }
        });
        /**
         * Go to url
         * @param name route name
         * @param query query value
         */
        function goUrl(name, query = null) {
            viewStore.toggleDrawer(false);
            vueRouter.push({
                name, query: query || {}
            });
        }
        return (_ctx, _cache) => {
            const _component_q_menu = _resolveComponent("q-menu");
            return (_openBlock(), _createBlock(generalHeader, { "home-header": __props.homeHeader }, {
                default: _withCtx(() => [
                    ((_unref(styleType) === 'desktop') && !__props.hideHeader)
                        ? (_openBlock(), _createBlock(desktopHeader, _normalizeProps(_mergeProps({ key: 0 }, headerComponentProperties.value)), null, 16))
                        : (_unref(styleType) === 'mobile')
                            ? (_openBlock(), _createBlock(mobileHeader, { key: 1 }))
                            : _createCommentVNode("", true),
                    _createElementVNode("div", null, [
                        ((_unref(styleType) === 'mobile') && !__props.homeHeader)
                            ? (_openBlock(), _createBlock(_component_q_menu, {
                                key: 0,
                                fit: "",
                                modelValue: drawer.value,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((drawer).value = $event)),
                                "transition-show": "slide-down",
                                "no-parent-event": "",
                                id: "mobile-header-menu"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(mobileOptions, {
                                        onInbox: _cache[0] || (_cache[0] = ($event) => (goUrl('Inbox', { tab: 'inbox' }))),
                                        onNotifications: _cache[1] || (_cache[1] = ($event) => (goUrl('Notifications'))),
                                        onClose: _cache[2] || (_cache[2] = ($event) => (drawer.value = false))
                                    })
                                ]),
                                _: 1
                            }, 8, ["modelValue"]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _: 1
            }, 8, ["home-header"]));
        };
    }
});
